import {
  parseKmlCoordTriplet
} from './portal-kml-utils.js'

const _ = window._
const L = window.L

const xmlToObj = function (el) {
  const children = Array.from(el.children || [])
  const attrs = Array.from(el.attributes || [])
  const hasAttrs = attrs.length > 0
  if (!children.length && !hasAttrs) {
    return (el.textContent || '').trim()
  }
  const obj = {}
  attrs.forEach((attr) => {
    obj['@' + attr.name] = attr.value
  })
  const textVal = (el.textContent || '').trim()
  if (!children.length) {
    if (textVal) obj._text = textVal
    return obj
  }
  children.forEach((child) => {
    const key = child.tagName
    const val = xmlToObj(child)
    if (obj[key] === undefined) {
      obj[key] = val
    } else if (Array.isArray(obj[key])) {
      obj[key].push(val)
    } else {
      obj[key] = [obj[key], val]
    }
  })
  return obj
}

const updateXmlByPath = function (xmlEl, path, value, fnScheduleKmzUpdateTimeTouch) {
  if (!xmlEl || !path) return false
  const parts = path.split('.').filter(Boolean)
  let cur = xmlEl
  for (let i = 0; i < parts.length; i++) {
    const tag = parts[i]
    if (tag === '_text') {
      if (i !== parts.length - 1) return false
      cur.textContent = (value === null || value === undefined) ? '' : String(value)
      fnScheduleKmzUpdateTimeTouch(path)
      return true
    }
    if (tag.startsWith('@')) {
      if (i !== parts.length - 1) return false
      const attrName = tag.slice(1)
      if (!attrName) return false
      cur.setAttribute(attrName, (value === null || value === undefined) ? '' : String(value))
      fnScheduleKmzUpdateTimeTouch(path)
      return true
    }
    if (/^\d+$/.test(tag)) {
      continue
    }
    let idx = 0
    if (i + 1 < parts.length && /^\d+$/.test(parts[i + 1])) {
      idx = parseInt(parts[i + 1], 10)
      i++
    }
    const children = Array.from(cur.children || []).filter(ch => ch.tagName === tag)
    if (!children.length) return false
    cur = children[idx] || children[0]
  }
  cur.textContent = (value === null || value === undefined) ? '' : String(value)
  fnScheduleKmzUpdateTimeTouch(path)
  return true
}

const updateXmlCoordinates = function (xmlEl, lat, lng, fnScheduleKmzUpdateTimeTouch) {
  if (!xmlEl) return false
  const coordEl = xmlEl.getElementsByTagName('coordinates')[0]
  if (!coordEl) return false
  const parsed = parseKmlCoordTriplet(coordEl.textContent)
  const alt = parsed && parsed.alt !== null ? parsed.alt : null
  coordEl.textContent = (alt === null)
    ? (String(lng) + ',' + String(lat))
    : (String(lng) + ',' + String(lat) + ',' + String(alt))
  fnScheduleKmzUpdateTimeTouch('Point.coordinates')
  return true
}

const pointSetSelected = function (point, selected, fnSetMarkerStyle) {
  if (!point || !point.marker) return
  point._selected = selected
  if (selected) {
    fnSetMarkerStyle(point.marker, { color: '#fff', weight: 3 })
  } else if (point._style) {
    fnSetMarkerStyle(point.marker, point._style)
  }
}

const selectClear = function (selectedPoints, fnPointSetSelected) {
  const list = Array.isArray(selectedPoints) ? selectedPoints : []
  list.forEach((pt) => fnPointSetSelected(pt, false))
  return []
}

const selectToggle = function (selectedPoints, point, fnPointSetSelected) {
  if (!point) return Array.isArray(selectedPoints) ? selectedPoints : []
  const list = Array.isArray(selectedPoints) ? selectedPoints.slice() : []
  const exists = list.includes(point)
  if (exists) {
    fnPointSetSelected(point, false)
    return list.filter(p => p !== point)
  }
  list.push(point)
  fnPointSetSelected(point, true)
  return list
}

const selectAllPoints = function (allPoints, fnPointSetSelected) {
  const points = Array.isArray(allPoints) ? allPoints : []
  const selectedPoints = []
  points.forEach((pt) => {
    if (!pt) return
    selectedPoints.push(pt)
    fnPointSetSelected(pt, true)
  })
  return selectedPoints
}

const buildDividePointsPopupHtml = function (selectedCount, maxPairDistance) {
  const tpl = window.jQuery('[data-tpl-divide-points-popup]').html()
  if (!tpl) return ''
  return tpl
    .replace('__SELECTED_COUNT__', String(selectedCount))
    .replace('__MAX_PAIR_DISTANCE__', Number(maxPairDistance).toFixed(1))
}

const buildMapFunctionsPopupHtml = function () {
  const tpl = window.jQuery('[data-tpl-map-functions-popup]').html()
  return String(tpl || '').trim()
}

const buildDemLoadingPopupHtml = function () {
  const tpl = window.jQuery('[data-tpl-dem-loading-popup]').html()
  return String(tpl || '').trim()
}

const getMarkerStyle = function (marker) {
  if (marker instanceof L.CircleMarker) {
    return {
      color: marker.options.color,
      weight: marker.options.weight,
      fillColor: marker.options.fillColor,
      fillOpacity: marker.options.fillOpacity
    }
  }
  return marker._customStyle || {
    color: '#111',
    weight: 2,
    fillColor: '#fff',
    fillOpacity: 0.8
  }
}

const registerImportPoint = function (point, marker) {
  point.marker = marker
  point._style = getMarkerStyle(marker)
}

const pointInPolygon = function (point, polygon) {
  const x = point.lng
  const y = point.lat
  let inside = false
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i].lng
    const yi = polygon[i].lat
    const xj = polygon[j].lng
    const yj = polygon[j].lat
    const intersect = ((yi > y) !== (yj > y)) &&
      (x < ((xj - xi) * (y - yi)) / (yj - yi + 0.0) + xi)
    if (intersect) inside = !inside
  }
  return inside
}

const setMarkerStyle = function (marker, style) {
  if (marker instanceof L.CircleMarker) {
    marker.setStyle(style)
    return
  }
  marker._customStyle = _.extend({}, marker._customStyle || {}, style)
  const apply = function () {
    const el = marker.getElement && marker.getElement()
    if (!el) return
    const tri = el.querySelector('.import-point-tri')
    if (!tri) return
    const s = marker._customStyle || style
    if (s.color) tri.setAttribute('stroke', s.color)
    if (s.weight !== undefined) tri.setAttribute('stroke-width', String(s.weight))
    if (s.fillColor) tri.setAttribute('fill', s.fillColor)
    if (s.fillOpacity !== undefined) tri.setAttribute('fill-opacity', String(s.fillOpacity))
  }
  if (marker.getElement && marker.getElement()) {
    apply()
  } else {
    marker.once('add', apply)
  }
}

const getPointXmlNodes = function (point) {
  if (!point) return []
  const nodes = []
  if (point.xmlEl) nodes.push(point.xmlEl)
  const linked = Array.isArray(point.linkedXmlEls) ? point.linkedXmlEls : []
  linked.forEach((node) => {
    if (node) nodes.push(node)
  })
  return nodes
}

const updatePointXmlByPath = function (point, path, value, fnUpdateXmlByPath) {
  getPointXmlNodes(point).forEach((node) => {
    fnUpdateXmlByPath(node, path, value)
  })
}

const updatePointCoordinates = function (point, lat, lng, fnUpdateXmlCoordinates) {
  getPointXmlNodes(point).forEach((node) => {
    fnUpdateXmlCoordinates(node, lat, lng)
  })
}

const removePointXmlNodes = function (point) {
  getPointXmlNodes(point).forEach((node) => {
    if (node && node.parentNode) {
      node.parentNode.removeChild(node)
    }
  })
}

const syncPlacemarkOrder = function (parentEl, points) {
  if (!parentEl) return
  const elementChildren = Array.from(parentEl.children || []).filter((child) => {
    return !!child && child.nodeType === 1
  })
  const isPlacemarkNode = function (node) {
    const tag = String(node && node.tagName || '')
    return tag === 'Placemark' || tag.endsWith(':Placemark')
  }
  let anchorAfterPlacemarkBlock = null
  const firstPlacemarkIdx = elementChildren.findIndex((child) => isPlacemarkNode(child))
  if (firstPlacemarkIdx >= 0) {
    for (let i = firstPlacemarkIdx + 1; i < elementChildren.length; i += 1) {
      const candidate = elementChildren[i]
      if (isPlacemarkNode(candidate)) continue
      anchorAfterPlacemarkBlock = candidate
      break
    }
  }
  const toRemove = elementChildren.filter((child) => isPlacemarkNode(child))
  toRemove.forEach((child) => {
    parentEl.removeChild(child)
  })
  points.forEach((pt) => {
    if (!pt || !pt.xmlEl) return
    if (anchorAfterPlacemarkBlock && anchorAfterPlacemarkBlock.parentNode === parentEl) {
      parentEl.insertBefore(pt.xmlEl, anchorAfterPlacemarkBlock)
    } else {
      parentEl.appendChild(pt.xmlEl)
    }
  })
}

const resolveInsertPlacementForLatLng = function (waypoints, latlng, map) {
  const points = Array.isArray(waypoints) ? waypoints : []
  if (!points.length) {
    return {
      insertIndex: 0,
      segmentIndex: -1,
      t: null,
      startPoint: null,
      endPoint: null
    }
  }
  if (points.length === 1) {
    return {
      insertIndex: 1,
      segmentIndex: 0,
      t: null,
      startPoint: points[0],
      endPoint: null
    }
  }
  const clickPoint = map.latLngToLayerPoint(latlng)
  let minDistance = Infinity
  let bestSegmentIndex = 0
  let bestT = 0.5
  for (let i = 0; i < points.length - 1; i++) {
    const p1 = map.latLngToLayerPoint(L.latLng(points[i].latlng[0], points[i].latlng[1]))
    const p2 = map.latLngToLayerPoint(L.latLng(points[i + 1].latlng[0], points[i + 1].latlng[1]))
    const vx = p2.x - p1.x
    const vy = p2.y - p1.y
    const wx = clickPoint.x - p1.x
    const wy = clickPoint.y - p1.y
    const vv = (vx * vx) + (vy * vy)
    const rawT = vv > 0 ? ((wx * vx) + (wy * vy)) / vv : 0
    const t = Math.max(0, Math.min(1, rawT))
    const cx = p1.x + (vx * t)
    const cy = p1.y + (vy * t)
    const dx = clickPoint.x - cx
    const dy = clickPoint.y - cy
    const distance = Math.sqrt((dx * dx) + (dy * dy))
    if (distance < minDistance) {
      minDistance = distance
      bestSegmentIndex = i
      bestT = t
    }
  }
  return {
    insertIndex: bestSegmentIndex + 1,
    segmentIndex: bestSegmentIndex,
    t: bestT,
    startPoint: points[bestSegmentIndex] || null,
    endPoint: points[bestSegmentIndex + 1] || null
  }
}

const findInsertIndexForLatLng = function (waypoints, latlng, map) {
  return resolveInsertPlacementForLatLng(waypoints, latlng, map).insertIndex
}

const createInsertedPoint = function (basePoint, latlng, altitudeOverride, ctx) {
  if (!basePoint) return null
  const baseAltitude = Number(basePoint.altitude)
  const resolvedAltitude = Number(altitudeOverride)
  const missionAltContext = ctx.fnGetMissionAltitudeContextFor3d(ctx.importMissionState)
  const newPoint = {
    idx: 0,
    latlng: [latlng.lat, latlng.lng],
    altitude: Number.isFinite(resolvedAltitude)
      ? resolvedAltitude
      : (Number.isFinite(baseAltitude) ? baseAltitude : basePoint.altitude),
    props: _.cloneDeep(basePoint.props || {}),
    xmlEl: basePoint.xmlEl ? basePoint.xmlEl.cloneNode(true) : null,
    linkedXmlEls: Array.isArray(basePoint.linkedXmlEls) ? basePoint.linkedXmlEls.map(node => node.cloneNode(true)) : []
  }
  if (!newPoint.props || typeof newPoint.props !== 'object') {
    newPoint.props = {}
  }
  if (!newPoint.props.coordinates || typeof newPoint.props.coordinates !== 'object') {
    newPoint.props.coordinates = {}
  }
  newPoint.props.coordinates.lat = latlng.lat
  newPoint.props.coordinates.lng = latlng.lng
  ctx.fnUpdatePointCoordinates(newPoint, latlng.lat, latlng.lng)
  if (Number.isFinite(Number(newPoint.altitude))) {
    ctx.fnApplyPointHeightValue(newPoint, Number(newPoint.altitude), missionAltContext)
  }
  if (ctx.fnTemplateSupportsPointCoordinatesField()) {
    const pointCoordinatesText = ctx.fnBuildPointCoordinatesText(newPoint.props || {})
    ctx.fnSetByPath(newPoint.props, 'Point.coordinates', pointCoordinatesText)
    ctx.fnUpdatePointXmlByPath(newPoint, 'Point.coordinates', pointCoordinatesText)
  }
  return newPoint
}

export {
  xmlToObj,
  updateXmlByPath,
  updateXmlCoordinates,
  pointSetSelected,
  selectClear,
  selectToggle,
  selectAllPoints,
  buildDividePointsPopupHtml,
  buildMapFunctionsPopupHtml,
  buildDemLoadingPopupHtml,
  registerImportPoint,
  getMarkerStyle,
  pointInPolygon,
  setMarkerStyle,
  getPointXmlNodes,
  updatePointXmlByPath,
  updatePointCoordinates,
  removePointXmlNodes,
  syncPlacemarkOrder,
  resolveInsertPlacementForLatLng,
  findInsertIndexForLatLng,
  createInsertedPoint
}
